import React, { useState, useEffect } from 'react';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';

const STATUS_OPTIONS = ['pending', 'processing', 'completed', 'cancelled'];

const SupplyOrderList = () => {
    const [orders, setOrders] = useState([]);
    const [pendingStatus, setPendingStatus] = useState({});

    const fetchOrders = async () => {
        try {
            const res = await getRequest('supply-order');
            setOrders(res?.data || []);
        } catch (err) {
            console.error('Error fetching supply orders:', err);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    const handleStatusChange = (orderId, status) => {
        setPendingStatus((prev) => ({ ...prev, [orderId]: status }));
    };

    const handleStatusUpdate = async (orderId) => {
        const status = pendingStatus[orderId];
        if (!status) return;
        try {
            await patchRequest(`supply-order/${orderId}`, { status });
            toast.success('Order status updated & serviceman notified!');
            fetchOrders();
        } catch (err) {
            console.error('Error updating supply order:', err);
            toast.error('Failed to update order status.');
        }
    };

    const tableHeaders = [
        {
            Header: 'Order ID',
            accessor: 'order_id',
        },
        {
            Header: 'Serviceman',
            accessor: 'servicemen.name',
            Cell: ({ row }) => row.original.servicemen?.name || '-',
        },
        {
            Header: 'Mobile',
            accessor: 'servicemen.mobile',
            Cell: ({ row }) => row.original.servicemen?.mobile || '-',
        },
        {
            Header: 'Items',
            accessor: 'items',
            Cell: ({ row }) => (
                <ul className="mb-0 pl-3">
                    {(row.original.items || []).map((item) => (
                        <li key={item.id}>
                            {item.item_name} ({item.item_type}) x {item.quantity} = ₹{item.subtotal}
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            Header: 'Total Amount',
            accessor: 'total_amount',
            Cell: ({ row }) => `₹${row.original.total_amount}`,
        },
        {
            Header: 'Payment Method',
            accessor: 'payment_method',
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => {
                const orderId = row.original.order_id;
                const currentValue = pendingStatus[orderId] ?? row.original.status;
                return (
                    <div className="d-flex align-items-center">
                        <select
                            className="form-control form-control-sm mr-2"
                            style={{ width: 130 }}
                            value={currentValue}
                            onChange={(e) => handleStatusChange(orderId, e.target.value)}
                        >
                            {STATUS_OPTIONS.map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                        <button
                            className="btn editbtn btn-sm"
                            disabled={currentValue === row.original.status}
                            onClick={() => handleStatusUpdate(orderId)}
                        >
                            Update
                        </button>
                    </div>
                );
            },
        },
        {
            Header: 'Created Date',
            accessor: 'createdAt',
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Supply Orders (Chemicals & Machines)</h4>
            </div>
            {orders?.length > 0 && (
                <AdminTable tableHeaders={tableHeaders} tableData={orders} />
            )}
        </div>
    );
};

export default SupplyOrderList;
